import { useForm } from "react-hook-form";
import { useLabelsContext } from "../context/LabelsContext";
import { useCallback } from "react";

export const useOtpForm = () => {
    const { labels } = useLabelsContext();

    const {
        register,
        handleSubmit,
        trigger,
        setError,
        formState: { errors },
    } = useForm<{ otp: string }>({
        mode: "onSubmit",
        reValidateMode: "onChange",
    });
    const otpForm = {
        otp: {
            required: labels?.["RequiredField"],
            validate: (value: string) =>
                /^\d+$/.test(value) || labels?.["TokenNotExist"] || "Numbers only"
        }
    }
    const getErrorMessage = useCallback((field: "otp"): { key: string, message: string } | null => {
        if (!errors[field]?.message) return null;
        const errorMessage = String(errors[field]?.message ?? "");
        const labelKey = Object.keys(labels || {}).find(key => labels?.[key] === errorMessage);

        return {
            key: labelKey ?? "",
            message: errorMessage
        };
    }, [errors, labels]);

    return {
        register,
        handleSubmit,
        trigger,
        setError,
        otpForm,
        errors,
        getErrorMessage
    }
}
